<template>
  <transition name="fade">
    <div class="phrase-overlay" v-if="admin_regist_modal">
      <div class="create-phrase-wrap">
        <div class="list-create">
          <div class="newmessage-title">
            新規登録
            <div class="flex-space"></div>
            <div class="newmessage-button" @click="closeModal()">
              <font-awesome-icon :icon="['fal', 'times']" />
            </div>
          </div>
          <div class="modal-content">
            <el-form style="width:100%" @submit.native.prevent="registAdminData(tableName)">
              <div v-for="(column, index) in registColumns" :key="index" class="setting-subwrap">
                <div class="setting-subtitle">{{column.label_ja}}<span style="color:#aaa">（{{ column.label }}）</span></div>
                <el-form-item class="setting-form">
                  <el-input :id="'value-' + index" v-model="column.value" size="small" v-show="column.inputType == 'input'"></el-input>
                  <div v-show="column.inputType == 'upload'">
                    <input :id="'value-' + index" type="file" @change="onFileChange($event, index)" accept="image/*" />
                    <div v-if="column.value" class="image-preview">
                      <img :src="column.value" alt="Image preview" />
                    </div>
                  </div>
                </el-form-item>
              </div>
              <div class="divider-nomargin"></div>
              <div class="wrap-title" style="width:100%">
                <div class="flex-space"></div>
                <el-button type="primary" size="small" native-type="submit" :disabled="loading">登録</el-button>
                <div class="loader--mini" v-show="loading"></div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const root = process.env.VUE_APP_API;
const registAPI = root + "/api/admin/admin_regist";

export default {
  name: "adminRegist",
  props: ['admin_regist_modal', 'registColumns', 'tableName'],
  components: {},
  data() {
    return {
      loading: false,
      root: root,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  mounted() {

  },
  methods: {
    registAdminData(tableName) {
      const h = this.$createElement;
        this.$msgbox({
          title: "新規登録",
          type: "warning",
          message: h("p", null, [h("span", null, "登録しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
          showCancelButton: true,
          confirmButtonClass: "danger",
          confirmButtonText: "登録",
          cancelButtonText: "キャンセル",
        })
          .then(() => {
            this.loading = true;
            var params = new URLSearchParams();
            params.append("token", this.token);
            params.append("type", tableName);
            const registdata = this.registColumns.map(column => ({
                              label: column.label,
                              label_ja: column.label_ja,
                              value: column.value,
                          }));
            params.append("regist_data", JSON.stringify(registdata));
            this.axios
              .post(registAPI, params)
              .then((response) => {
                this.loading = false;
                if (response.data.status == "OK") {
                  this.closeModal();
                  this.$emit("load");
                  this.$message({
                    message: response.data.message,
                    type: "success",
                    offset: 7,
                    showClose: true,
                  });
                } else {
                  this.$message({
                    message: response.data.message,
                    type: "error",
                    offset: 7,
                    showClose: true,
                  });
                }
              })
              .catch(() => {
                this.loading = false;
              });
            })
        .catch(() => {
        });
    },
    closeModal() {
      this.$emit("update:admin_regist_modal", false);
    },
    onFileChange(event, index) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(this.registColumns[index], 'value', e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
  },
  filters: {},
  watch: {
  },
};
</script>
